import PropTypes from "prop-types";
import { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Link,
  Button,
  Drawer,
  Typography,
  Avatar,
  Stack,
  Container
} from "@mui/material";
// components
import Logo from "../../components/Logo";
import Scrollbar from "../../components/Scrollbar";
import NavSection from "../../components/NavSection";
import { MHidden } from "../../components/@material-extend";
//
import {
  sidebarAdminConfig,
  sidebarMentorConfig,
  sidebarPostDocConfig,
  sidebarPhD3yConfig,
  sidebarPhD5yConfig
} from "./SidebarConfig";

// ----------------------------------------------------------------------

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const DRAWER_WIDTH = 280;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  userRole: PropTypes.string
};

export default function DashboardSidebar({
  isOpenSidebar,
  onCloseSidebar,
  userRole
}) {
  const { pathname } = useLocation();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);

  // const fullName = `${currentUser.name} ${currentUser.surname}`;

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      style={{ backgroundColor: "#DE7694" }}
      sx={{
        height: "100%",
        "& .simplebar-content": {
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }}>
        {/* <Box
          component={RouterLink}
          to="/member"
          sx={{ display: "inline-flex" }}
        >
          <Logo />
        </Box> */}
      </Box>

 
      <NavSection
        navConfig={
          userRole === ROLE_ADMIN
            ? sidebarAdminConfig
            : userRole === ROLE_MENTOR
            ? sidebarMentorConfig
            : userRole === ROLE_PHD_3Y
            ? sidebarPhD3yConfig
            : userRole === ROLE_PHD_5Y
            ? sidebarPhD5yConfig
            : userRole === ROLE_POSTDOC
            ? sidebarPostDocConfig
            : []
        }
      />
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: "background.default"
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
